import { Component, OnInit, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';

import { AuthService } from '../../services/auth.service';
import { EnvService } from '../../services/env.service';

@Component({
	selector: 'app-admheader',
	templateUrl: './admheader.component.html',
	styleUrls: ['./admheader.component.css']
})
export class AdmheaderComponent implements OnInit {

	autoOrder:any;

	logi_user:any;
	orderCnt:number = 0;

	audio:any;

	@Input() admPageObj1: string;
	@Input() admPageObj2: string;
	@Input() admPageObj3: string;
	@Input() admPageObj4: string;
	@Input() admPageObj5: string;
	@Input() admPageObj6: string;
	@Input() admPageObj7: string;
	@Input() admPageObj100: string;
	@Input() admPageObj200: string;
	@Input() admPageObj300: string;
	@Input() admPageObj400: string;

	constructor(
		private http: HttpClient,
		private router: Router,

		private env: EnvService,
		private authService: AuthService,
	) {
		this.audio = new Audio();
		this.audio.src = '/assets/audio/alarm.mp3';
		this.audio.load();
	}

	ngOnInit() {
		this.adminAuthChk();

		this.orderLatestCnt();

		this.autoOrder = setInterval(() => {
			this.orderLatestCnt();
		}, 3000);
	}

	async adminAuthChk() {
		this.logi_user = await this.authService.getToken();

		var formData: any = new FormData();
		formData.append("logi_user", this.logi_user);
		formData.append("logi_code", this.env.COM_CODE);

		this.http.post(this.env.API_URL + 'api/admin.auth.php', formData).subscribe((response) => {
			if( response['code'] != 1000 )
			{
				this.router.navigate(['/order']);
			}
		});
	}

	async orderLatestCnt() {
		this.logi_user = await this.authService.getToken();

		var formData: any = new FormData();
		formData.append("logi_user", this.logi_user);
		formData.append("logi_code", this.env.COM_CODE);

		this.http.post(this.env.API_URL + 'api/order.cnt.php', formData).subscribe((response) => {
			this.orderCnt = response['cnt'];

			if( response['alarm_cnt'] )
			{
				this.playAudio();
			}
		});
	}

	playAudio(): void {
		this.audio.play();
	}
}
